export const SET_APP_INFO = "electron/set_app_info"
export const SET_APP_INSTALLED = "electron/set_app_installed"
